import styled from 'styled-components';

export const ManageStyled = styled.section`
  padding: 64px 0;
  background-color: #e2e6e8;

  @media screen and (min-width: 992px) {
    padding: 140px 0;
  }
`;

export const Article = styled.article`
  margin-bottom: 80px;
  &:last-child {
    margin-bottom: 0;
  }

  @media screen and (min-width: 992px) {
    grid-column: 2/12;
    display: grid;
    grid-template-columns: repeat(10, 1fr);
    grid-gap: 15px;
  }

  .desktop-hidden {
    @media screen and (min-width: 992px) {
      display: none;
    }
  }

  .mobile-hidden {
    display: none;

    @media screen and (min-width: 992px) {
      display: block;
    }
  }

  .swap-order-1 {
    @media screen and (min-width: 992px) {
      grid-row: 1;
      grid-column: 1/6;
      align-self: center;
    }
  }

  .swap-order-2 {
    @media screen and (min-width: 992px) {
      grid-row: 1;
      grid-column: 7/11;
      align-self: center;
    }
  }
`;

export const TextBlock = styled.div`
  @media screen and (min-width: 992px) {
    grid-column: 1/5;
    align-self: center;
  }
`;

export const Title = styled.h2`
  margin: 0 0 8px;
  font-size: 20px;
  line-height: 1.5;
  color: #333333;

  @media screen and (min-width: 992px) {
    font-size: 24px;
  }
`;

export const Description = styled.p`
  margin: 0 0 30px;
  font-size: 16px;
  line-height: 1.7;
  color: #727272;
`;

export const Link = styled.a`
  text-decoration: none;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 1px;
  line-height: 1.7;
  color: #0d96c6;

  &:after {
    content: '';
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: 10px;
    border-top: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-left: 6px solid #0d96c6;
  }
`;

export const Figure = styled.figure`
  position: relative;
  display: flex;
  flex-direction: column;
  margin-top: 40px;
  overflow: hidden;

  &:before {
    position: absolute;
  }

  @media screen and (min-width: 992px) {
    grid-column: 6/11;
    margin-top: 0;
  }

  img {
    width: 100%;
    max-width: 100%;
  }

  &.with-shadow {
    box-shadow: 0 15px 35px rgba(50, 50, 93, 0.1), 0 5px 15px rgba(0, 0, 0, 0.07);
  }
`;

export const BottomNote = styled.div`
  h2 {
    margin: 0 0 8px;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 1px;
    line-height: 1.7;
    text-transform: uppercase;
    color: #eb5424;
  }

  img {
    display: none;

    @media screen and (min-width: 992px) {
      display: block;
      max-width: 100%;
    }

    &.url-bar {
      padding-top: 10px;
      margin-bottom: 40px;
    }
  }

  p {
    margin: 0;
    font-size: 16px;
    line-height: 27px;
    color: #727272;
  }

  b {
    font-weight: 500;
  }

  em {
    font-weight: 500;
    font-style: normal;
    color: #eb5424;
  }

  &.sdk {
    margin-top: 40px;

    h2 {
      display: flex;
      align-items: center;
      margin: 0 0 16px;
      color: #333333;
    }

    img {
      display: inline-block;
      max-width: 20px;
      margin-right: 12px;

      @media screen and (min-width: 992px) {
        max-width: 100%;
        margin-right: 16px;
      }
    }
  }

  &.dot {
    p {
      position: relative;
      padding-left: 24px;

      &:before {
        content: '';
        position: absolute;
        top: 8px;
        left: 0;
        width: 6px;
        height: 6px;
        background-color: #333333;
      }
    }
  }
`;

export const DomainDiagram = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px;
  margin: 0 0 40px;
  background-color: white;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);

  span {
    font-size: 20px;
    line-height: 40px;
    text-align: center;
    color: #727272;

    &.orange {
      color: #eb5424;
    }
  }

  p {
    line-height: 27.2px;
    font-size: 16px;
    color: #727272;

    &.orange {
      color: #eb5424;
    }
  }

  .connector {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 8px 8px 0 8px;
    border-color: #eb5224 transparent transparent transparent;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/universal-login/components/Manage/styled.js